import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=efbf8060&scoped=true&"
import script from "./mine.vue?vue&type=script&lang=js&"
export * from "./mine.vue?vue&type=script&lang=js&"
import style0 from "./mine.vue?vue&type=style&index=0&id=efbf8060&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbf8060",
  null
  
)

export default component.exports